import { render, staticRenderFns } from "./saasList.vue?vue&type=template&id=456cc93b&scoped=true"
import script from "./saasList.vue?vue&type=script&lang=js"
export * from "./saasList.vue?vue&type=script&lang=js"
import style0 from "./saasList.vue?vue&type=style&index=0&id=456cc93b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cc93b",
  null
  
)

export default component.exports